import React, { useState, useEffect } from 'react';
import { useGetAllNamirniceQuery } from '../features/Namirnice/namirniceApiSlice';
import { useGetAllIshraneQuery } from '../features/ishrana/ishranaApiSlice';
import { useGetAllSpecCiljeviQuery } from '../features/ciljevi/ciljeviApiSlice';

function IshranaTable() {
  const [ishrane, setIshrane] = useState([]);
  const [availableNamirnice, setAvailableNamirnice] = useState([]);
  const [grupisaneNamirnice, setGrupisaneNamirnice] = useState({});
  const [odabraneNamirnice, setOdabraneNamirnice] = useState([]);
  const [disabledNamirnice, setDisabledNamirnice] = useState([]); // Drži disabled checkboxove
  const [selectedIshrana, setSelectedIshrana] = useState('');
  const [specilj, setSpecilj] = useState('');

  const [specCiljevi, setSpecCiljevi] = useState([]);
  const [selectedDefTip, setSelectedDefTip] = useState(''); 
  const [filteredSpecCiljevi, setFilteredSpecCiljevi] = useState([]);
  const [selectedSpecCiljevi, setSelectedSpecCiljevi] = useState([]);


  const { isSuccess: isSuccessGetNamir, isError: isErrorGetNamir, error: getNamirError, data: getNamirData } = useGetAllNamirniceQuery();
  const { isSuccess: isSuccessGetIsh, isError: isErrorGetIsh, error: getIshError, data: getIshData } = useGetAllIshraneQuery();
  const { isSuccess: isSuccessGetSpecCiljevi, isError: isErrorGetSpecCiljevi, error: getSpecCiljeviError, data: getSpecCiljeviData } = useGetAllSpecCiljeviQuery();

  const onSpecCiljChanged = (e) => setSpecilj(e.target.value);

  // Get Ishrane
  useEffect(() => {
    if (isSuccessGetIsh) {
      setIshrane(Object.values(getIshData.entities || []));
    }
    if (isErrorGetIsh) {
      const errorMessage = getIshError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetIsh, isErrorGetIsh, getIshError, getIshData]);

  // Get Namirnice
  useEffect(() => {
    if (isSuccessGetNamir) {
      setAvailableNamirnice(Object.values(getNamirData.entities || {}));

      const grupisaneNamirnice_ = Object.values(getNamirData.entities || {}).reduce((acc, namirnica) => {
        if (!acc[namirnica.grupa]) {
          acc[namirnica.grupa] = {};
        }
        if (!acc[namirnica.grupa][namirnica.podtip]) {
          acc[namirnica.grupa][namirnica.podtip] = [];
        }
        acc[namirnica.grupa][namirnica.podtip].push(namirnica);
        return acc;
      }, {});
      setGrupisaneNamirnice(grupisaneNamirnice_);
    }

    if (isErrorGetNamir) {
      const errorMessage = getNamirError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetNamir, isErrorGetNamir, getNamirError, getNamirData]);

  // Kada promenimo ishranu, resetuj namirnice na osnovu te ishrane NOVO
  const handleIshranaChange = (e) => {
    const selectedIshranaId = e.target.value;
    setSelectedIshrana(selectedIshranaId);
    setDisabledNamirnice([]); // Resetuj disabled checkboxove

    if (selectedIshranaId === '') {
      setOdabraneNamirnice([]); // Resetuj odabrane namirnice ako nije odabrana ishrana
    } else {
      const odabranaIshrana = ishrane.find((ishrana) => ishrana._id === selectedIshranaId);

      if (odabranaIshrana) {
        setOdabraneNamirnice(odabranaIshrana.namirnice || []); // Postavi namirnice iz izabrane ishrane
      }
    }
  };

  // Kada promenimo specifičan cilj, resetuj namirnice i oduzmi checkboxove cilja, a te checkboxove onemogući NOVO
  useEffect(() => {
    if (specilj && selectedIshrana) {
      const odabranaIshrana = ishrane.find((ishrana) => ishrana._id === selectedIshrana);

      if (odabranaIshrana) {
        setOdabraneNamirnice(odabranaIshrana.namirnice || []);

        const odabraniCilj = getSpecCiljeviData.entities[specilj];

        if (odabraniCilj && odabraniCilj.namirnice) {
          setOdabraneNamirnice((prev) =>
            prev.filter((namirnicaId) => !odabraniCilj.namirnice.includes(namirnicaId))
          );

          // Postavi disabled checkboxove na osnovu specifičnog cilja
          setDisabledNamirnice(odabraniCilj.namirnice);
        }
      }
    }
  }, [specilj, selectedIshrana, getSpecCiljeviData, ishrane]);

  // Handle promenu namirnica (dodaj ili ukloni iz odabranih namirnica)
  const handleNamirnicaChange = (event) => {
    const value = event.target.value;
    setOdabraneNamirnice((prev) => {
      if (prev.includes(value)) {
        return prev.filter((id) => id !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  useEffect(() => { 
    if (isSuccessGetSpecCiljevi) {
        setSpecCiljevi(Object.values(getSpecCiljeviData?.entities || {}));
    }

    if (isErrorGetSpecCiljevi) {
        const errorMessage = getSpecCiljeviError?.data?.message;
        alert(errorMessage);
    }
  }, [isSuccessGetSpecCiljevi, isErrorGetSpecCiljevi, getSpecCiljeviError]);

  const uniqueDefTip = [...new Set(specCiljevi.map(item => item.defTip))];

  useEffect(() => {
      if (selectedDefTip) {
          const filtered = specCiljevi.filter(item => item.defTip === selectedDefTip);
          setFilteredSpecCiljevi(filtered);
      } else {
          setFilteredSpecCiljevi([]);
      }
  }, [selectedDefTip, specCiljevi]);

  const onDefTipChanged = (e) => {
      setSelectedDefTip(e.target.value);
      setSelectedSpecCiljevi([]); // Resetuj izabrane specifične ciljeve
  };

  const handleCheckboxChangeSpecCilj = (ciljId) => {
    setSelectedSpecCiljevi((prevSelected) => {
      const newSelected = prevSelected.includes(ciljId)
        ? prevSelected.filter(id => id !== ciljId) // Ukloni ako je već izabran
        : [...prevSelected, ciljId]; // Dodaj ako nije izabran
  
      if (selectedIshrana) {
        const odabranaIshrana = ishrane.find((ishrana) => ishrana._id === selectedIshrana);
        if (odabranaIshrana) {
          const namirniceSve = odabranaIshrana.namirnice || [];
          const namirniceZaUklanjanje = new Set(); // Skup za namirnice koje treba ukloniti
  
          // Kada se selektuje, dodajemo namirnice koje pripadaju tom cilju
          if (newSelected.includes(ciljId)) {
            const odabraniCilj = getSpecCiljeviData.entities[ciljId];
            if (odabraniCilj && odabraniCilj.namirnice) {
              odabraniCilj.namirnice.forEach(namirnicaId => {
                namirniceZaUklanjanje.add(namirnicaId);
              });
            }
          }
  
          // Uklanjamo sve namirnice povezane sa svim selektovanim ciljevima
          if (newSelected.length > 0) {
            // Uklanjamo namirnice
            setOdabraneNamirnice((prev) =>
              prev.filter(namirnicaId => !namirniceZaUklanjanje.has(namirnicaId))
            );
          } else {
            // Ako su svi ciljevi odselektovani, vraćamo sve namirnice
            setOdabraneNamirnice(namirniceSve);
          }
        }
      }
  
      // Logika za odselektovanje
      if (!newSelected.includes(ciljId)) {
        // Vraćamo samo namirnice koje su vezane za odabrani cilj
        const odabraniCilj = getSpecCiljeviData.entities[ciljId];
        if (odabraniCilj && odabraniCilj.namirnice) {
          const namirniceZaVracanje = odabraniCilj.namirnice.filter(namirnicaId => {
            return !newSelected.some(selectedCiljId => {
              const cilј = getSpecCiljeviData.entities[selectedCiljId];
              return cilј && cilј.namirnice.includes(namirnicaId);
            });
          });
  
          // Vraćamo namirnice koje nisu vezane za ostale ciljeve
          setOdabraneNamirnice((prev) => [
            ...prev,
            ...namirniceZaVracanje.filter(id => !prev.includes(id))
          ]);
        }
      }
  
      return newSelected;
    });
  };


  useEffect(() => {
    if (isSuccessGetNamir) {
      const grupisaneNamirnice_ = Object.values(getNamirData.entities || {}).reduce((acc, namirnica) => {
        acc[namirnica.grupa] = acc[namirnica.grupa] || {};
        acc[namirnica.grupa][namirnica.podtip] = acc[namirnica.grupa][namirnica.podtip] || [];
        acc[namirnica.grupa][namirnica.podtip].push(namirnica);
        return acc;
      }, {});
  
      setGrupisaneNamirnice(grupisaneNamirnice_);
      setAvailableNamirnice(Object.values(getNamirData.entities || {}));
    }
  }, [isSuccessGetNamir, getNamirData]);

  return (
    <>
      <h3 className="text-sm font-medium leading-6 text-gray-900 whitespace-nowrap">Izaberite ishranu</h3>
      <select
        id="options"
        name="options"
        value={selectedIshrana}
        onChange={handleIshranaChange}
        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
      >
        <option value="">Izaberi ishranu</option>
        {ishrane.map((ishrana) => (
          <option key={ishrana._id} value={ishrana._id}>
            {ishrana.naziv}
          </option>
        ))}
      </select>

      <div>
            <label htmlFor="defTip" className="block text-sm font-medium leading-6 text-gray-900 mt-4">
                Izaberite tip
            </label>
            <div className="mt-1">
                <select
                    id="defTip"
                    name="defTip"
                    value={selectedDefTip}
                    onChange={onDefTipChanged}
                    className="block w-full rounded border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600"
                >
                    <option value="">Izaberite tip</option>
                    {uniqueDefTip.map((tip, index) => (
                        <option key={index} value={tip}>
                            {tip}
                        </option>
                    ))}
                </select>
            </div>

            <label className="block text-sm font-medium leading-6 text-gray-900 mt-4">
                Specifičan cilj
            </label>
            <div className="mt-1">
                {filteredSpecCiljevi.length > 0 ? (
                    filteredSpecCiljevi.map((cilj) => (
                        <div key={cilj._id} className="flex items-center">
                            <input
                                type="checkbox"
                                id={cilj._id}
                                checked={selectedSpecCiljevi.includes(cilj._id)}
                                onChange={() => handleCheckboxChangeSpecCilj(cilj._id)}
                                className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <label htmlFor={cilj._id} className="ml-2 block text-sm text-gray-900">
                                {cilj.naziv}
                            </label>
                        </div>
                    ))
                ) : (
                    <div>Učitavanje...</div>
                )}
            </div>

            {/* Prikaz izabranih specifičnih ciljeva */}
            <div className="mt-4">
                <h3 className="text-lg font-medium">Izabrani specifični ciljevi:</h3>
                <ul className="mt-2 list-disc list-inside">
                    {selectedSpecCiljevi.map((ciljId) => {
                        const cilj = specCiljevi.find(c => c._id === ciljId);
                        return cilj ? (
                            <li key={ciljId}>{cilj.naziv}</li>
                        ) : null;
                    })}
                </ul>
            </div>
        </div>

      {/* Prikaz namirnica po kategorijama i podkategorijama */}
      {selectedIshrana ? (
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2">Odabir Namirnica</h3>
          <div className="overflow-y-scroll" style={{ maxHeight: '400px' }}>
            {Object.keys(grupisaneNamirnice).map((grupa) => (
              <div key={grupa} className="mb-4">
                <h3 className="text-lg font-semibold">{grupa}</h3>
                {Object.keys(grupisaneNamirnice[grupa]).map((podtip) => (
                  <div key={podtip} className="ml-4 mb-2">
                    <h4 className="text-md font-medium">{podtip}</h4>
                    <div className="ml-6">
                      {grupisaneNamirnice[grupa][podtip].map((namirnica) => (
                        <div key={namirnica._id} className="flex items-center mb-1">
                          <input
                            type="checkbox"
                            value={namirnica._id}
                            checked={odabraneNamirnice.includes(namirnica._id)}
                            onChange={handleNamirnicaChange}
                            className="mr-2"
                            disabled={
                              disabledNamirnice.includes(namirnica._id) ||
                              !ishrane
                                .find((ishrana) => ishrana._id === selectedIshrana)?.namirnice.includes(namirnica._id)
                            } // Disable checkbox ako namirnica nije deo izabrane ishrane ili cilja
                          />
                          <label>
                            {namirnica.naziv}{' '}
                            {namirnica.alergen
                              ? '(Alergen)'
                              : namirnica.gluten
                              ? '(Sadrži Gluten)'
                              : namirnica.laktoza
                              ? '(Sadrži Laktozu)'
                              : ''}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <p>Izaberite ishranu</p>
      )}
    </>
  );
}

export default IshranaTable;
